import { baseApi } from "api/BaseApi";
import { UserUploadedFile } from "api/memberPortal/files/files.types";

import { FrontendFileUploadPayload, PclFileResponse } from "./file.types";

const FILE_BASE_URL = "file";

export const publicFileApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    pclFiles: build.query<PclFileResponse, string | number>({
      query: (productId) => ({
        url: `${FILE_BASE_URL}/get_pcl_files/`,
        params: { product_id: productId },
      }),
    }),

    publicFile: build.query<Blob, string | number>({
      query: (fileId) => ({
        url: `${FILE_BASE_URL}/get_public_file/`,
        params: { file_id: fileId },
        responseHandler: (response) => response.blob(),
      }),
    }),

    uploadFrontendFile: build.mutation<
      UserUploadedFile,
      FrontendFileUploadPayload
    >({
      query: (payload) => {
        const formData = new FormData();
        formData.set("file", payload.file);
        formData.set("file_type_id", payload.file_type_id.toString());
        formData.set("file_type", payload.file_type);
        formData.set("file_display_name", payload.file_display_name);
        formData.set("file_name", payload.file_name);
        formData.set("file_label", payload.file_label);
        formData.set("active", payload.active.toString());
        formData.set("uploaded_on", payload.uploaded_on);

        return {
          url: `${FILE_BASE_URL}/upload_frontend_files/`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["FILES"],
    }),
  }),

  overrideExisting: false,
});

export const {
  usePclFilesQuery,
  useLazyPublicFileQuery,
  useUploadFrontendFileMutation,
} = publicFileApi;
